var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___ZjBEUT",
  "Un": "AuthPageStyles.module__errorContainer___ZjBEUT",
  "ik": "AuthPageStyles.module__errorIcon___ZjBEUT",
  "gi": "AuthPageStyles.module__errorIconSvg___ZjBEUT",
  "JU": "AuthPageStyles.module__errorTitle___ZjBEUT",
  "kc": "AuthPageStyles.module__errorText___ZjBEUT",
  "kL": "AuthPageStyles.module__container___ZjBEUT",
  "TQ": "AuthPageStyles.module__entityHeader___ZjBEUT",
  "Ep": "AuthPageStyles.module__entityDetails___ZjBEUT",
  "Pp": "AuthPageStyles.module__entityText___ZjBEUT",
  "j2": "AuthPageStyles.module__entityTitleWrapper___ZjBEUT",
  "wD": "AuthPageStyles.module__entityTitle___ZjBEUT",
  "N2": "AuthPageStyles.module__entityStats___ZjBEUT",
  "So": "AuthPageStyles.module__entityStat___ZjBEUT",
  "RS": "AuthPageStyles.module__onlineDot___ZjBEUT",
  "FD": "AuthPageStyles.module__offlineDot___ZjBEUT",
  "KA": "AuthPageStyles.module__statText___ZjBEUT",
  "Wp": "AuthPageStyles.module__entityIconWrapper___ZjBEUT",
  "fq": "AuthPageStyles.module__entityIcon___ZjBEUT",
  "Ly": "AuthPageStyles.module__themeIconSpot___ZjBEUT",
  "J3": "AuthPageStyles.module__themeIcon___ZjBEUT",
  "Zd": "AuthPageStyles.module__form___ZjBEUT",
  "ee": "AuthPageStyles.module__registrationNotice___ZjBEUT",
  "Gr": "AuthPageStyles.module__bottomLink___ZjBEUT",
  "fH": "AuthPageStyles.module__bottomLinkText___ZjBEUT",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___ZjBEUT",
  "cB": "AuthPageStyles.module__usernameHint___ZjBEUT",
  "Jy": "AuthPageStyles.module__suggestionLink___ZjBEUT",
  "LB": "AuthPageStyles.module__usernameError___ZjBEUT",
  "$M": "AuthPageStyles.module__consentRow___ZjBEUT",
  "t6": "AuthPageStyles.module__consentLabel___ZjBEUT",
  "Rf": "AuthPageStyles.module__policyLink___ZjBEUT",
  "ii": "AuthPageStyles.module__disabledContainer___ZjBEUT",
  "aV": "AuthPageStyles.module__disabledText___ZjBEUT",
  "ax": "AuthPageStyles.module__disabledSubtext___ZjBEUT",
  "SO": "AuthPageStyles.module__disabledActions___ZjBEUT",
  "ns": "AuthPageStyles.module__disabledActionLink___ZjBEUT",
  "DD": "AuthPageStyles.module__title___ZjBEUT",
  "Zo": "AuthPageStyles.module__giftIconContainer___ZjBEUT",
  "ez": "AuthPageStyles.module__giftIcon___ZjBEUT",
  "PM": "AuthPageStyles.module__entitySubtext___ZjBEUT",
  "W$": "AuthPageStyles.module__subtext___ZjBEUT",
};

module.exports = exports;
